export default class PurchaseOrderItemDetail  {

    constructor() {

        this.productCode = '';
        this.productDescription = '';
        this.qtyRequired = '';
        this.qtyReceived = '';
        this.qtyRemaining = '';
        this.weight = '';
        this.unitOfWeight = '';
        this.itemPrice = '';
        this.lineItemTotalprice = '';
    }
}
